import Router from "next/router";
import React, { useCallback } from "react";
import { useDeleteProtocol } from "../../../data/mutations/useDeleteProtocol";
import { ProtocolItem } from "../../../types";
import { Button } from "../Button";
import { Dialog } from "../Dialog";

type DeleteProtocolDialogProps = {
  open: boolean;
  onOpenChange: (value: boolean) => void;
  protocol: ProtocolItem;
};

export const DeleteProtocolDialog = ({
  protocol,
  open,
  onOpenChange,
}: DeleteProtocolDialogProps) => {
  const [deleteProtocol] = useDeleteProtocol();

  const onProtocolDelete = useCallback(() => {
    deleteProtocol({ variables: { id: protocol.id } });
    Router.push("/protocols");
  }, [protocol.id, deleteProtocol]);

  return (
    <Dialog.Dialog open={open} onOpenChange={onOpenChange}>
      <Dialog.Content>
        <Dialog.Title>Delete protocol</Dialog.Title>
        <Dialog.Description>
          Are you sure you want to delete this protocol? This action cannot be undone.
        </Dialog.Description>
        <Dialog.Footer>
          <Dialog.Close>
            <Button
              variant="primary"
              text="Delete protocol"
              onClick={() => {
                onProtocolDelete();
              }}
            />
          </Dialog.Close>
          <Dialog.Close>
            <Button variant="ghost" text="Cancel" />
          </Dialog.Close>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Dialog>
  );
};
